/**
 * @author xiaohuangmaoth
 * @date 2020-09-08
 * @desc 内容查看
 */
import React from "react";
import { connect } from "dva";
import { Descriptions } from "antd";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import columns from "./columns";
import { AuditForm } from './components'
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import "./index.less";

const { WizContainer, modelUtils, ossFileUtils } = framework_tool;
const { WizSpin, WizCard, WizEmpty, WizInput, WizRow, WizCol, WizTable, WizModal, WizBraftEditor } = component_tool;
const { TextArea } = WizInput;
const { Session } = utils_tool
const { getOssImgResizeUrl } = ossFileUtils

import { getDetailRecord } from '@/containers/content/util'

class ContentView extends WizContainer {
  componentName = "ContentView";

  constructor(props) {
    super(props);
    this.state = {
      record: {},
      programContent: [],
      scheduleModalVisible: false,
      courseFileData: {},
      richTextIntro: '',
    };
    this.detailInfo = getDetailRecord(props.history);
  }

  _componentDidMount() {
    this.doAction({
      path: "courseApplication/getInfo",
      payload: {
        key: "getInfo",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    getInfo: this._getInfo.bind(this),
  };

  _getInfo(nextProps, nextState) {
    const { getInfo } = nextProps;
    if (getInfo["success"] && getInfo["data"]) {
      console.log(getInfo["data"], 'getInfo["data"]')

      // let contentTextList = getInfo["data"].detailValue['contentList']
      // if (contentTextList && contentTextList.length) {
      //   contentTextList = contentTextList.sort((a, b) => { return a.id - b.id })
      // }
      // console.log(contentTextList,'contentTextList')
      nextState.record = {
        ...this.getInfo, ...getInfo.data,
        // contentTextList
      };
      return true;
    } else {
      wizNotice.error(getInfo['msg'] || "获取数据失败请稍后在试")
    }
    return false;
  }

  // getContentListByContentType = (contentType, contentTextList, hiddenType = 0) => {
  //   switch (contentType) {
  //     case 1:
  //       return (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html:
  //               contentTextList.length && contentTextList[0].contentDetail,
  //           }}
  //         ></div>
  //       );
  //     case 2:
  //       return <Images data={contentTextList} />;
  //     case 3:
  //     case 4:
  //     case 5:
  //       return <Video data={contentTextList} />;
  //     default:
  //       return <WizEmpty />;
  //   }
  // };
  openLook = (record) => {
    this.setState({ scheduleModalVisible: true, courseFileData: record })
  }
  openRichText = (record) => {
    this.setState({ richTextVisible: true, richTextIntro: record })
  }
  _createIntro = (requirement) => {
    if (requirement && document.getElementById("knowledge_intro") != null) {
      document.getElementById(
        "knowledge_intro"
      ).innerHTML = WizBraftEditor.createEditorState(requirement).toHTML();
    }
  }
  _render() {
    const { courseApplicationLoading } = this.props;
    const { record, richTextIntro } = this.state;
    return (
      <WizSpin spinning={courseApplicationLoading}>
        <WizCard>
          <Descriptions column={1} bordered={true}>
            {columns(record, this.openLook, this.openRichText).map((val, index) => (
              <Descriptions.Item key={index} label={val.label}>
                {val.value}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </WizCard>
        <WizModal visible={this.state.scheduleModalVisible}
          onCancel={() => this.setState({ scheduleModalVisible: false })}
          footer={null}
          style={{ minWidth: 1000 }}
          title={`查看课程内容-${this.state.courseFileData.contentType == 0 ? '课件' : '考试'}`}
        // key={this.state.scheduleListModalKey}
        >
          <AuditForm data={this.state.courseFileData} cancel={this.cancel} />
        </WizModal>
        <WizModal visible={this.state.richTextVisible}
          onCancel={() => this.setState({ richTextVisible: false })}
          footer={null}
          style={{ minWidth: 1000 }}
          title='介绍'
        // key={this.state.scheduleListModalKey}
        >
          <div className="rich-text-style"
            dangerouslySetInnerHTML={{
              __html: richTextIntro
            }}
          />        </WizModal>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { courseApplication } = state;
  const getInfo = modelUtils.getModelEntity(courseApplication, "getInfo");
  const load = modelUtils.getLoadingState(state, "courseApplication");
  return {
    getInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(ContentView);

function Images({ data }) {

  return (
    <WizRow className="images-view-wrp" gutter={[12, 12]}>
      {data && data.length ? (
        data.map((val, index) => (
          <WizCol key={index.toString()} xs={24} sm={12} md={8} lg={6}>
            <WizRow type="flex" gutter={2} className="image-item">
              <WizCol span={14} className="image-item-imgbox">
                <img
                  className="image-item-img"
                  src={getOssImgResizeUrl(val.fileUri, {
                    m: "lfit",
                    w: 300,
                    h: 200,
                  }, true)}
                  alt=""
                />
              </WizCol>
              <WizCol span={10} className="image-item-desc">
                <TextArea
                  // placeholder="请输入描述..."
                  style={{ height: '100%' }}
                  value={val.contentDetail}
                  readOnly
                ></TextArea>
              </WizCol>
            </WizRow>
          </WizCol>
        ))
      ) : (
        <WizEmpty />
      )}
    </WizRow>
  );
}

function Video({ data }) {
  return data && data.length ? (
    <Descriptions column={1}>
      {data.map((val, index) => (
        <Descriptions.Item key={index} label={`文件${index + 1}`}>
          {val.fileName} <span style={{ marginLeft: 10 }}>({(val.fileSize / 1024).toFixed(1)}KB)</span>
        </Descriptions.Item>
      ))}
    </Descriptions>
  ) : (
    <WizEmpty />
  );
}
